import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./Home.css";
import homeImage from "../../assets/homeImage.jpg";

import img1 from "../../assets/gallery/gallery_image1.jpg";
import img2 from "../../assets/gallery/gallery_image2.jpg";
import img3 from "../../assets/gallery/gallery_image3.jpg";
import img4 from "../../assets/gallery/gallery_image4.jpg";
import img5 from "../../assets/gallery/gallery_image5.jpg";
import img6 from "../../assets/gallery/gallery_image6.jpg";
import img7 from "../../assets/gallery/gallery_image7.jpg";
import img8 from "../../assets/gallery/gallery_image8.jpg";

const formatDate = (date) => {
  if (!date) return "";
  if (typeof date === "string") return date;
  if (typeof date.toDate === "function")
    return date.toDate().toISOString().slice(0, 10);
  if (date.seconds)
    return new Date(date.seconds * 1000).toISOString().slice(0, 10);
  return "";
};

const formatTime = (time) => {
  if (!time) return "";
  if (typeof time === "string") return time;
  if (typeof time.toDate === "function") {
    const date = time.toDate();
    return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }
  if (time.seconds) {
    const date = new Date(time.seconds * 1000);
    return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }
  return "";
};

const Home = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventsRef = collection(db, "events");
        const q = query(eventsRef, orderBy("date", "asc"));
        const querySnapshot = await getDocs(q);

        const fetchedEvents = querySnapshot.docs.map((doc) => {
          const data = doc.data();

          return {
            id: doc.id,
            ...data,
            date: formatDate(data.date),
            startTime: formatTime(data.startTime),
            endTime: formatTime(data.endTime),
          };
        });
        console.log(fetchedEvents);
        setEvents(fetchedEvents);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <div>
      <Header />
      <main className="home-container">
        <div className="hero-image">
          <img src={homeImage} alt="Keira with sound bowls" />
        </div>

        {events.length > 0 && (
          <section className="event-section">
            <h3 className="event-section-title">Upcoming Events</h3>
            <div className="event-grid">
              {events.map((event) => {
                const dateObj = new Date(event.date);
                const weekday = dateObj.toLocaleDateString(undefined, {
                  weekday: "long",
                });
                const fullDate = dateObj.toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                });

                return (
                  <div className="event-card" key={event.id}>
                    <div>
                      <p className="event-title">{event.title}</p>
                    </div>
                    <div className="event-date">
                      <div className="event-day">{weekday}</div>
                      <div className="event-full-date">{fullDate}</div>
                      <div className="event-time">
                        {event.startTime} – {event.endTime} {event.timezone}
                      </div>
                    </div>

                    <div className="event-content">
                      <p className="event-description">{event.description}</p>
                      <p className="event-location">
                        <strong>{event.venue}</strong>
                        <br />
                        {event.address}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="event-section-button">
              <a
                href="https://www.eventbrite.com/o/into-sound-healing-112788866831"
                className="event-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Tickets
              </a>
            </div>
          </section>
        )}

        <section className="intro-text">
          <h2>Into Sound Healing</h2>
          <p>
            At Into Sound Healing, we offer a sanctuary for the mind and spirit
            in the midst of a fast-moving world. Rooted in the belief that sound
            is a powerful tool for restoration, our sessions are thoughtfully
            designed to help release stress, calm the nervous system, and invite
            a deep sense of peace. Whether you're navigating the pressures of
            daily life, recovering from burnout, or simply seeking stillness,
            Into Sound Healing offers a gentle yet profound path back to
            balance. Through curated sound journeys—using crystal bowls, gongs,
            and harmonic tones—we help you reconnect with yourself and create
            space for healing from within.
          </p>

          <div className="image-gallery">
            {[img1, img2, img3, img4, img5, img6, img7, img8].map(
              (src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Gallery image ${index + 1}`}
                  className="gallery-image"
                />
              )
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
